import { clearField, resetField } from '..';
import { getNamespaceState } from '../state';
/**
 * Reset namespace, but ignoring the default values of the  fields
 * @param namespace
 */

export var clearNamespace = function clearNamespace(namespace) {
  var fieldNames = Object.keys(getNamespaceState(namespace));
  fieldNames.forEach(function (fieldName) {
    clearField(namespace, fieldName);
  });
};
/**
 * Reset namespace to default state and setting last provided default value per field
 * @param namespace
 */

export var resetNamespace = function resetNamespace(namespace) {
  var fieldNames = Object.keys(getNamespaceState(namespace));
  fieldNames.forEach(function (fieldName) {
    resetField(namespace, fieldName);
  });
};